export enum RegisterStepOneResponse {
  DEFAULT,
  RESEND,
}
